import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { usersApi } from '@/api/endpoints'
import { keys } from '@/api/keys'
import type { MutedWord } from '@/api/types'
import { useToast } from '@/components/ui/Toast'
import { useT } from '@/i18n'

export function useMutedWords() {
  return useQuery({ queryKey: keys.mutedWords(), queryFn: usersApi.mutedWords })
}

/** 静音词一变，时间线、搜索、话题页的结果都可能变，统统作废重取。 */
function invalidateFeeds(client: ReturnType<typeof useQueryClient>) {
  client.invalidateQueries({ queryKey: keys.timelineRoot() })
  client.invalidateQueries({ queryKey: keys.searchRoot() })
}

export function useAddMutedWord() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (phrase: string) => usersApi.addMutedWord(phrase),
    onSuccess: (word) => {
      client.setQueryData<MutedWord[]>(keys.mutedWords(), (current = []) => [
        word,
        ...current.filter((w) => w.id !== word.id),
      ])
      invalidateFeeds(client)
    },
  })
}

export function useRemoveMutedWord() {
  const t = useT()
  const client = useQueryClient()
  const toast = useToast()
  return useMutation({
    mutationFn: (id: string) => usersApi.removeMutedWord(id),
    onSuccess: (_result, id) => {
      client.setQueryData<MutedWord[]>(keys.mutedWords(), (current = []) =>
        current.filter((w) => w.id !== id),
      )
      invalidateFeeds(client)
    },
    onError: () => toast.error(t('toast.deleteFailed')),
  })
}
